import React from 'react';
import PropTypes from 'prop-types';

import { FormGroup, Input, FormFeedback, DefaultTable, ButtonIcon } from 'twyne-new.ui';

import { Trash } from 'lucide-react';

class GroupOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidOptions: props.invalidOptions,
      options: props.options
    }
  }

  componentWillReceiveProps({options,invalidOptions}){
    this.setState({options,invalidOptions})
  }

  handleChange(state){
    this.setState(state);
    this.props.handleChange && this.props.handleChange(state);
  }

  addOption = () => {
    let options = this.state.options;
    options.push({ value: '', label: '' });
    this.handleChange({ options });
  }

  removeOption = (index) => {
    let options = this.state.options;
    options.splice(index, 1);
    this.handleChange({ options });
  }

  handleChangeOptionInput = (index, field, value) => {
    let {options,invalidOptions} = this.state;
    value = field==='value' ? value.replace(/\W+/g,'') : value;
    options[index][field] = value;
    invalidOptions[index] && (invalidOptions[index][field] = undefined);
    this.handleChange({ options,invalidOptions });

  }

  render() {
    const { options, invalidOptions } = this.state;
    const { placeholder } = this.props;

    const columns = [
      {
        dataField: 'value',
        text: placeholder.value,
        formatter: (cell, row, index) => {
          const invalidValue = invalidOptions[index] && invalidOptions[index].value;
          return <FormGroup>
            <Input
              value={row.value}
              name={`key_${row.value}`}
              placeholder={placeholder.value}
              onChange={e => this.handleChangeOptionInput(index, 'value', e.target.value)}
              invalid={!!invalidValue}
              disabled={row.disabled}
            />
            {invalidValue && <FormFeedback>{invalidValue}</FormFeedback>}
          </FormGroup>
        }
      },
      {
        dataField: 'label',
        text: placeholder.label,
        formatter: (cell, row, index) => {
          const invalidLabel = invalidOptions[index] && invalidOptions[index].label;
          return <FormGroup>
            <Input
              value={row.label}
              name={`value_${row.value}`}
              placeholder={placeholder.label}
              onChange={e => this.handleChangeOptionInput(index, 'label', e.target.value)}
              invalid={!!invalidLabel}
            />
            {invalidLabel && <FormFeedback>{invalidLabel}</FormFeedback>}
          </FormGroup>
        }
      },
      {
        dataField: 'id',
        text: '',
        formatter: (cell, row, index) => <ButtonIcon>
          <Trash size={16} className='cursor-pointer' onClick={() => this.removeOption(index)} />
        </ButtonIcon>
      }
    ];

    if (options?.length === 0) return null;

    return <DefaultTable
      columns={columns}
      data={options}
      className='max-h-[30vh] overflow-y-auto'
    />
  }
}

GroupOptions.defaultProps={
  placeholder: { value: 'Key', label: 'Value'},
  options: [],
  invalidOptions: []
}

GroupOptions.propTypes = {
  handleChange: PropTypes.func,
  invalidOptions: PropTypes.array,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.any
};

export default GroupOptions;
